import { useEffect, useRef, useState } from "react";

export const useDebounce = <T>(value: T, delay: number) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		// Cleanup function to clear the timeout if value changes
		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
};

export function useDebouncedCallback(
	callback: () => void,
	delay: number,
	deps: any[],
) {
	const handler = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (handler.current) {
			clearTimeout(handler.current);
		}

		handler.current = setTimeout(() => {
			callback();
		}, delay);

		return () => {
			if (handler.current) {
				clearTimeout(handler.current);
			}
		};
	}, [...deps, delay, callback]);
}
